import React from 'react';

import Default from '@common/blocks/image/Default';
import AccordionImages from '@common/blocks/image/accordion-images/AccordionImages';
import Glossary from '@common/blocks/image/glossary/Glossary';
import Gallery from '@common/blocks/image/gallery/Gallery';
import ImageRow from '@common/blocks/image/row/ImageRow';
import ImageRowWrap from '@common/blocks/image/row-wrap/ImageRowWrap';
import RebrandFixedImages from '@common/blocks/image/rebrand-fixed-images/RebrandFixedImages';
import WhiteBoxSlider from '@common/blocks/image/white-box-slider/WhiteBoxSlider';
import Border from '@common/blocks/image/border/Border';
import Badges from '@common/blocks/image/badges/Badges';

const components = [
  {
    component: Default,
    key: 'Default'
  },
  {
    component: AccordionImages,
    key: 'Accordion with Images'
  },
  {
    component: Glossary,
    key: 'Glossary'
  },
  {
    component: Gallery,
    key: 'Gallery'
  },
  {
    component: ImageRow,
    key: 'Row'
  },
  {
    component: ImageRowWrap,
    key: 'Row - Wrap'
  },
  {
    component: RebrandFixedImages,
    key: 'Rebrand Fixed Images'
  },
  {
    component: Border,
    key: 'Border'
  },
  {
    component: WhiteBoxSlider,
    key: 'White Box Slider'
  },
  {
    component: Badges,
    key: 'Badges'
  }
];

const ImageBlock = ({ data }) => {
  const { style } = data;
  const Component = components.find(x => x.key === style)?.component || Default;
  return <Component data={data}/>;
}

export default ImageBlock
